var map = {
	"./de/general4/slide2.svg": 99594,
	"./en/general4/slide2.svg": 675934,
	"./es/general4/slide2.svg": 868271,
	"./fr/general4/slide2.svg": 978823,
	"./nl/general4/slide2.svg": 890045,
	"./pt/general4/slide2.svg": 99563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59774;